import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { AuthService } from './auth.service';
import { environment } from '../../environments/environment';
import { catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { TestResultsDataForm } from '../_models/test-results-data-form';

@Injectable()
export class TestResultsService {

  

  public static readonly URL_TESTRESULTS_CONTROLLER = environment.apiUrl + '/testResults/';

  public static readonly URL_SAVE_USER_RESULTS = TestResultsService.URL_TESTRESULTS_CONTROLLER + "saveUserTestResults/";
  public static readonly URL_GET_USER_TEST_RESULTS = TestResultsService.URL_TESTRESULTS_CONTROLLER + "getByUserId/";
 
  constructor(private http: HttpClient, private authService: AuthService) { }

  // save Test Results
  saveUserTestResuts(testResultsDataForm: TestResultsDataForm) {
    let userToken: string = this.authService.getUserToken();
    return this.http.post(TestResultsService.URL_SAVE_USER_RESULTS + userToken,testResultsDataForm)
      .pipe(catchError(this.handleError('Request Failed')));
  }


  getUserTestResults(userId,testType) {
    let userToken: string = this.authService.getUserToken();
    return this.http.post(TestResultsService.URL_GET_USER_TEST_RESULTS + userId + '/'  +testType + '/'+userToken,userId,testType)
      .pipe(catchError(this.handleError('Request Failed')));
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: HttpErrorResponse) => {
      console.log(error);
      if (error.status === 401) {
        localStorage.removeItem('currentUser');
        window.location.replace('');
      }
      return Observable.throw(error);
    };
  }

}
